// extracted by mini-css-extract-plugin
export var basicLayout = "basicArticleHero-module--basicLayout--7d661";
export var featuredImage = "basicArticleHero-module--featuredImage--db885";
export var featuredImageCaption = "basicArticleHero-module--featuredImageCaption--afb86";
export var postHeadline = "basicArticleHero-module--postHeadline--632e4";
export var subhead = "basicArticleHero-module--subhead--40ab8";